(function () {
  var popup = document.getElementById('DiscountPopup');
  if (!popup) return;

  var SEEN_KEY = 'fenixDiscountPopupClosedAt';
  var SUBSCRIBED_KEY = 'fenixDiscountPopupSubscribed';
  var SNOOZE_DAYS = 14;
  // Se muestra a los 25 s, al bajar la mitad de la página o (en escritorio)
  // al intentar salir, lo que ocurra primero; nunca al entrar.
  var SHOW_DELAY_MS = 25000;
  var SCROLL_DEPTH = 0.5;
  var EXIT_INTENT_MIN_MS = 10000;
  var startedAt = Date.now();
  var lastFocused = null;

  function open() {
    if (popup.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    popup.classList.add('is-open');
    var firstField = popup.querySelector('input:not([type="hidden"]), .discount-popup__copy');
    if (firstField && window.matchMedia('(min-width: 750px)').matches) {
      firstField.focus({ preventScroll: true });
    } else {
      var dialog = popup.querySelector('.discount-popup__dialog');
      if (dialog) dialog.focus({ preventScroll: true });
    }
  }

  function close() {
    popup.classList.remove('is-open');
    try {
      window.localStorage.setItem(SEEN_KEY, String(Date.now()));
    } catch (e) {}
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  }

  // No interrumpir a quien está escribiendo, tiene el carrito abierto o está en el carrito.
  function isBusy() {
    var active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return true;
    if (document.querySelector('cart-drawer.active, .drawer.active, details[open] > .menu-drawer')) return true;
    return /^\/cart/.test(window.location.pathname);
  }

  function scheduleOpen() {
    var done = false;
    var timer;

    function trigger() {
      if (done) return;
      if (isBusy()) {
        timer = window.setTimeout(trigger, 8000);
        return;
      }
      done = true;
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onMouseOut);
      open();
    }

    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= SCROLL_DEPTH) trigger();
    }

    function onMouseOut(event) {
      if (event.relatedTarget || event.clientY > 0) return;
      if (Date.now() - startedAt < EXIT_INTENT_MIN_MS) return;
      trigger();
    }

    timer = window.setTimeout(trigger, SHOW_DELAY_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', onMouseOut);
    }
  }

  function shouldShowOnLoad() {
    try {
      if (window.localStorage.getItem(SUBSCRIBED_KEY) === '1') return false;
      var closedAt = window.localStorage.getItem(SEEN_KEY);
      if (!closedAt) return true;
      var elapsedDays = (Date.now() - Number(closedAt)) / (1000 * 60 * 60 * 24);
      return elapsedDays > SNOOZE_DAYS;
    } catch (e) {
      return true;
    }
  }

  popup.querySelectorAll('[data-discount-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
  });

  if (popup.classList.contains('discount-popup--force-open')) {
    try {
      window.localStorage.setItem(SUBSCRIBED_KEY, '1');
    } catch (e) {}
    open();
  } else if (shouldShowOnLoad()) {
    scheduleOpen();
  }

  var copyButton = popup.querySelector('[data-copy-code]');
  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var codeEl = document.getElementById('DiscountPopupCode');
      if (!codeEl) return;
      var code = codeEl.textContent.trim();
      var originalLabel = copyButton.textContent;

      function showCopied() {
        copyButton.textContent = 'Copiado';
        window.setTimeout(function () {
          copyButton.textContent = originalLabel;
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied);
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
        } catch (e) {}
        document.body.removeChild(textarea);
        showCopied();
      }
    });
  }
})();
